export const StatsFormFields = (hideBlock?: "tracking" | "reference") => {
  const stats = [];

  if (!hideBlock || hideBlock !== "tracking") {
    stats.push({
      component: "Accordion",
      title: "Tracking Analytics",
      className: "tracking-analytics",
      iconLeft: true,
      initialState: false,
      formFields: [
        {
          component: "TrackingInputs",
          id: "trackingInputs",
          name: "trackingInputs",
          inputs: [
            {
              label: "_googleAnalyticsLabel",
              placeholder: "_googleAnalyticsPlaceholder",
              errorMessage: [
                { rule: "^G-[A-Z0-9]{7,10}$", message: "_googleAnalyticsInvalidFormat" },
              ],
              name: "googleAnalytics",
              id: "googleAnalytics",
              data_qa: "google-analytics-input",
            },
            {
              label: "_facebookPixelLabel",
              placeholder: "_facebookPixelPlaceholder",
              errorMessage: [{ rule: "^\\d{10,16}$", message: "_facebookPixelInvalidFormat" }],
              name: "facebookPixel",
              id: "facebookPixel",
              data_qa: "facebook-pixel-input",
            },
            {
              label: "_GTMLabel",
              placeholder: "_GTMPlaceholder",
              errorMessage: [
                { rule: "^(GTM|G)-[A-Z0-9]{8}$", message: "_googleTagManagerInvalidFormat" },
              ],
              name: "GTM",
              id: "GTM",
              data_qa: "gtm-input",
            },
          ],
        },
      ],
    });
  }

  if (!hideBlock || hideBlock !== "reference") {
    stats.push({
      component: "Accordion",
      title: "URL Configuration",
      className: "URLConfiguration",
      iconLeft: true,
      initialState: false,
      formFields: [
        {
          component: "SwitchWithInput",
          id: "customReferenceSwitch",
          label: "_switchLabel",
          checked: true,
          content: "_switchContent",
          name: "customReferenceSwitch",
          data_qa: "custom-link-switch",
          warning: "_warningContent",
          formFields: [
            {
              component: "Input",
              id: "customReference",
              type: "text",
              label: "URL",
              placeholder: "_customUrlPlaceholder",
              errorMessage: [
                { rule: "required", message: "_requiredMessage" },
                { rule: "maxLength", message: "_referenceMaxLength" },
              ],
              name: "customReference",
              data_qa: "custom-link-input",
              defaultValue: "_customUrlPlaceholder",
            },
          ],
        },
      ],
    });
  }

  return stats;
};
